import { render, staticRenderFns } from "./RecapCollecte.vue?vue&type=template&id=2b524a84&scoped=true"
import script from "./RecapCollecte.vue?vue&type=script&lang=js"
export * from "./RecapCollecte.vue?vue&type=script&lang=js"
import style0 from "./RecapCollecte.vue?vue&type=style&index=0&id=2b524a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b524a84",
  null
  
)

export default component.exports